import service from '@/utils/server';

const modName='/order/pickupNotice/';
const downloadFileModeName = '/common/web/download/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//预览pdf
export const previewSchOrder = data => {
  return service({
    url: modName + 'previewSchOrder',
    method: 'post',
    data
  });
};

//确认
export const confirm = data => {
  return service({
    url: modName + 'confirm',
    method: 'post',
    data
  });
};

//批量确认
export const batchConfirm = data => {
  return service({
    url: modName + 'batchConfirm',
    method: 'post',
    data
  });
};

export const modifyVendorTypeInitPage = data => {
  return service({
    url: modName + 'modifyVendorTypeInitPage/' + data,
    method: 'post',
    data
  });
};

export const modifyVendorTypeSubmit = data => {
  return service({
    url: modName + 'modifyVendorTypeSubmit',
    method: 'post',
    data
  });
}





// WEBPACK FOOTER //
// ./src/page/order/orderPickupNotice/api/index.js